<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <div
    class="min-h-screen bg-[var(--color-bg)] text-[var(--color-text)] flex flex-col">
    <div
      class="flex-1 flex flex-col gap-5 sm:gap-6 container-padding pb-24 py-4">
      <ModuleShell
        v-for="lang in languages"
        :key="lang.code"
        :title="lang.label"
        :icon="lang.icon"
        :compact="true"
        @click="select(lang.code)">
        <template #action>
          <Check v-if="isActive(lang.code)" class="w-5 h-5" />
          <span v-else class="w-5 h-5"></span>
        </template>
      </ModuleShell>
    </div>
  </div>
</template>

<script setup>
  import { computed,onMounted } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { Check, Globe } from 'lucide-vue-next'
  import { setLocale } from '@/i18n'
  import BackButton from '@/components/ui/buttons/GetBackButton.vue'
  import ModuleShell from '@/components/ui/layout/ModuleShell.vue'

  const { locale, t } = useI18n({ useScope: 'global' })
  const languageCodes = ['en', 'de']

  import { useUiStore } from '@/stores/ui.store.js' 
  const uiStore = useUiStore()

  onMounted(() => {
    uiStore.setHeader({
      title: t('views.more.language.title'), 
      showBack: true,
      showAdd: false
    })
  })

  const languages = computed(() =>
    languageCodes.map((code) => ({
      code,
      label: t(`views.more.language.languageNames.${code}`),
      icon: Globe,
    }))
  )

  const current = computed(() => locale.value)

  function select(code) {
    setLocale(code)
  }

  function isActive(code) {
    return current.value === code
  }
</script>
